enum NameEnum {
    HOME = "Home",
    ABOUT = "About",
    EXPERIENCE = "Experience",
    CONTACT = "Contact",
    FORM_SUBMITTED = "Form submitted",
    NOT_FOUND = "Not found",
}

export default NameEnum;
